// extracted by css-extract-rspack-plugin
export default {"colorFillPrimary":"#5c34cd","size400":"400px","size660":"660px","sizeFluid":"100%","columnChartContainer":"ColumnChart-module__columnChartContainer___OmAtk"};